import type { FC, ReactNode } from "react";
import { cn } from "@/lib/cn";

interface BadgeProps {
  variant:
    | "pending"
    | "running"
    | "completed"
    | "failed"
    | "duplicate"
    | "admin"
    | "user"
    | "success"
    | "warning"
    | "danger"
    | "default"
    | "info";
  children: ReactNode;
  className?: string;
}

const variants = {
  pending: "bg-yellow-400/15 text-yellow-200",
  running: "bg-brand/15 text-brand",
  completed: "bg-green-400/15 text-green-300",
  failed: "bg-red-400/15 text-red-300",
  duplicate: "bg-amber-400/15 text-amber-200",
  admin: "bg-brand/15 text-brand",
  user: "bg-slate-500/20 text-slate-300",
  success: "bg-green-400/15 text-green-300",
  warning: "bg-yellow-400/15 text-yellow-200",
  danger: "bg-red-400/15 text-red-300",
  default: "bg-slate-500/20 text-slate-300",
  info: "bg-brand/15 text-brand",
};

export const Badge: FC<BadgeProps> = ({ variant, children, className }) => (
  <span
    className={cn(
      "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium",
      variants[variant],
      className
    )}
  >
    {children}
  </span>
);
